import { createAsyncAction } from 'typesafe-actions'
import { Offer, OffersActionTypes } from './types'

export const createOffersAsync = createAsyncAction(
  OffersActionTypes.CREATE_OFFER_REQUEST,
  OffersActionTypes.CREATE_OFFER_SUCCESS,
  OffersActionTypes.CREATE_OFFER_FAILURE
)<{ offer: Partial<Offer>; onSuccess(): void }, Offer, Error>()
